import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { DLCompany } from './company';
import { DLCompanyService } from './company.service';
import { lookupParam } from '../../nav/utils';
import { NotifierService } from '../../ui';

@Injectable()
export class DLCompanyResolver implements Resolve<DLCompany> {

  constructor(
    private router: Router,
    private companyService: DLCompanyService,
    private notifier: NotifierService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): DLCompany | Observable<DLCompany> | Promise<DLCompany> {
    return new Promise<DLCompany>(async (resolve, reject) => {

      let company_id = lookupParam(route, 'company_id');

      this.notifier.startProgress();

      this.companyService
        .company(company_id)
        .subscribe((company) => {
          
          if(company) {
            return resolve(company);
          }
          else {
            this.router.navigate(['documents-ledger', 'companies']);
            return resolve(null);
          }
        });
    });
  }
}